/* eslint-disable */
import Long from 'long'
import * as _m0 from 'protobufjs/minimal'
import { GachaPartsSet } from '../../Gacha/Common/GachaPartsSet'

export const protobufPackage = 'Reality.Reality.Api'

/** おまけアイテムタイプ */
export enum GachaBonusItemType {
  GACHA_BONUS_ITEM_TYPE_UNKNOWN = 0,
  /** GACHA_BONUS_ITEM_TYPE_TICKET - ガチャチケ */
  GACHA_BONUS_ITEM_TYPE_TICKET = 1,
  /** GACHA_BONUS_ITEM_TYPE_AVATAR_POINT - アバターポイント */
  GACHA_BONUS_ITEM_TYPE_AVATAR_POINT = 2,
  /** GACHA_BONUS_ITEM_TYPE_AVATAR_ITEM - アバターアイテム */
  GACHA_BONUS_ITEM_TYPE_AVATAR_ITEM = 3,
  /** GACHA_BONUS_ITEM_TYPE_COIN - コイン（未使用） */
  GACHA_BONUS_ITEM_TYPE_COIN = 4,
  /** GACHA_BONUS_ITEM_TYPE_POINT - ポイント（未使用） */
  GACHA_BONUS_ITEM_TYPE_POINT = 5,
  /** GACHA_BONUS_ITEM_TYPE_LIVE_POINT - LIVEポイント（未使用） */
  GACHA_BONUS_ITEM_TYPE_LIVE_POINT = 6,
  UNRECOGNIZED = -1,
}

export function gachaBonusItemTypeFromJSON(object: any): GachaBonusItemType {
  switch (object) {
    case 0:
    case 'GACHA_BONUS_ITEM_TYPE_UNKNOWN':
      return GachaBonusItemType.GACHA_BONUS_ITEM_TYPE_UNKNOWN
    case 1:
    case 'GACHA_BONUS_ITEM_TYPE_TICKET':
      return GachaBonusItemType.GACHA_BONUS_ITEM_TYPE_TICKET
    case 2:
    case 'GACHA_BONUS_ITEM_TYPE_AVATAR_POINT':
      return GachaBonusItemType.GACHA_BONUS_ITEM_TYPE_AVATAR_POINT
    case 3:
    case 'GACHA_BONUS_ITEM_TYPE_AVATAR_ITEM':
      return GachaBonusItemType.GACHA_BONUS_ITEM_TYPE_AVATAR_ITEM
    case 4:
    case 'GACHA_BONUS_ITEM_TYPE_COIN':
      return GachaBonusItemType.GACHA_BONUS_ITEM_TYPE_COIN
    case 5:
    case 'GACHA_BONUS_ITEM_TYPE_POINT':
      return GachaBonusItemType.GACHA_BONUS_ITEM_TYPE_POINT
    case 6:
    case 'GACHA_BONUS_ITEM_TYPE_LIVE_POINT':
      return GachaBonusItemType.GACHA_BONUS_ITEM_TYPE_LIVE_POINT
    case -1:
    case 'UNRECOGNIZED':
    default:
      return GachaBonusItemType.UNRECOGNIZED
  }
}

export function gachaBonusItemTypeToJSON(object: GachaBonusItemType): string {
  switch (object) {
    case GachaBonusItemType.GACHA_BONUS_ITEM_TYPE_UNKNOWN:
      return 'GACHA_BONUS_ITEM_TYPE_UNKNOWN'
    case GachaBonusItemType.GACHA_BONUS_ITEM_TYPE_TICKET:
      return 'GACHA_BONUS_ITEM_TYPE_TICKET'
    case GachaBonusItemType.GACHA_BONUS_ITEM_TYPE_AVATAR_POINT:
      return 'GACHA_BONUS_ITEM_TYPE_AVATAR_POINT'
    case GachaBonusItemType.GACHA_BONUS_ITEM_TYPE_AVATAR_ITEM:
      return 'GACHA_BONUS_ITEM_TYPE_AVATAR_ITEM'
    case GachaBonusItemType.GACHA_BONUS_ITEM_TYPE_COIN:
      return 'GACHA_BONUS_ITEM_TYPE_COIN'
    case GachaBonusItemType.GACHA_BONUS_ITEM_TYPE_POINT:
      return 'GACHA_BONUS_ITEM_TYPE_POINT'
    case GachaBonusItemType.GACHA_BONUS_ITEM_TYPE_LIVE_POINT:
      return 'GACHA_BONUS_ITEM_TYPE_LIVE_POINT'
    default:
      return 'UNKNOWN'
  }
}

export interface GachaBonusItem {
  /** おまけアイテムID */
  itemId: number
  /** おまけを付与する回数 */
  drawCount: number
  /** おまけアイテムタイプ */
  type: GachaBonusItemType
  /** 付与数 */
  amount: number
  name: string
  partsSets: GachaPartsSet[]
}

function createBaseGachaBonusItem(): GachaBonusItem {
  return {
    itemId: 0,
    drawCount: 0,
    type: 0,
    amount: 0,
    name: '',
    partsSets: [],
  }
}

export const GachaBonusItem = {
  encode(
    message: GachaBonusItem,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.itemId !== 0) {
      writer.uint32(8).int64(message.itemId)
    }
    if (message.drawCount !== 0) {
      writer.uint32(16).int64(message.drawCount)
    }
    if (message.type !== 0) {
      writer.uint32(24).int32(message.type)
    }
    if (message.amount !== 0) {
      writer.uint32(32).int64(message.amount)
    }
    if (message.name !== '') {
      writer.uint32(42).string(message.name)
    }
    for (const v of message.partsSets) {
      GachaPartsSet.encode(v!, writer.uint32(50).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GachaBonusItem {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGachaBonusItem()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          message.itemId = longToNumber(reader.int64() as Long)
          break
        case 2:
          message.drawCount = longToNumber(reader.int64() as Long)
          break
        case 3:
          message.type = reader.int32() as any
          break
        case 4:
          message.amount = longToNumber(reader.int64() as Long)
          break
        case 5:
          message.name = reader.string()
          break
        case 6:
          message.partsSets.push(GachaPartsSet.decode(reader, reader.uint32()))
          break
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },

  fromJSON(object: any): GachaBonusItem {
    return {
      itemId: isSet(object.itemId) ? Number(object.itemId) : 0,
      drawCount: isSet(object.drawCount) ? Number(object.drawCount) : 0,
      type: isSet(object.type) ? gachaBonusItemTypeFromJSON(object.type) : 0,
      amount: isSet(object.amount) ? Number(object.amount) : 0,
      name: isSet(object.name) ? String(object.name) : '',
      partsSets: Array.isArray(object?.partsSets)
        ? object.partsSets.map((e: any) => GachaPartsSet.fromJSON(e))
        : [],
    }
  },

  toJSON(message: GachaBonusItem): unknown {
    const obj: any = {}
    message.itemId !== undefined && (obj.itemId = Math.round(message.itemId))
    message.drawCount !== undefined &&
      (obj.drawCount = Math.round(message.drawCount))
    message.type !== undefined &&
      (obj.type = gachaBonusItemTypeToJSON(message.type))
    message.amount !== undefined && (obj.amount = Math.round(message.amount))
    message.name !== undefined && (obj.name = message.name)
    if (message.partsSets) {
      obj.partsSets = message.partsSets.map((e) =>
        e ? GachaPartsSet.toJSON(e) : undefined
      )
    } else {
      obj.partsSets = []
    }
    return obj
  },

  fromPartial<I extends Exact<DeepPartial<GachaBonusItem>, I>>(
    object: I
  ): GachaBonusItem {
    const message = createBaseGachaBonusItem()
    message.itemId = object.itemId ?? 0
    message.drawCount = object.drawCount ?? 0
    message.type = object.type ?? 0
    message.amount = object.amount ?? 0
    message.name = object.name ?? ''
    message.partsSets =
      object.partsSets?.map((e) => GachaPartsSet.fromPartial(e)) || []
    return message
  },
}

declare var self: any | undefined
declare var window: any | undefined
declare var global: any | undefined
var globalThis: any = (() => {
  if (typeof globalThis !== 'undefined') return globalThis
  if (typeof self !== 'undefined') return self
  if (typeof window !== 'undefined') return window
  if (typeof global !== 'undefined') return global
  throw 'Unable to locate global object'
})()

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<
        Exclude<keyof I, KeysOfUnion<P>>,
        never
      >

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error('Value is larger than Number.MAX_SAFE_INTEGER')
  }
  return long.toNumber()
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any
  _m0.configure()
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}
